import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import TableManagementFilter from './components/TableManagementFilter';
import TableManagementTable from './components/TableManagementTable';
import { PageTitle } from '../../../components/Common/PageTitle';
import {
  EnumOrderMerchantToolFilter,
  EnumPage,
  EnumTableOrderStatus,
  EnumToggleType,
} from '../../../constants/enum';
import {
  changeFilters,
  closeDialogGeneric,
} from '../../../redux/genericAction';
import {
  getListIds,
  getListInfo,
  updateOrderInfo,
  updateOrderMerchantNote,
  updateOrderStatus,
} from './actions';
import { trans } from '../../../localization';
import { isEmpty, isEmptyObject } from '../../../utils/utils';
import './Table.scss';
import { ORDER_AUTO_RELOAD_INTERVAL } from '../../../constants/constants';
import TableReportOrderModal from './components/TableReportOrderModal/TableReportOrderModal';
import TableRejectOrderModal from './components/TableRejectOrderModal';
import TableMerchantNoteModal from './components/TableReportOrderModal/TableMerchantNoteModal';
import TableBillCodeAndTotalBillModal from './components/TableReportOrderModal/TableBillCodeAndTotalBillModal';

class TableManagement extends React.Component {
  state = {
    showingRejectReasonOrderId: null,
    showingReportReasonOrderId: null,
    showingMerchantNoteOrder: null,
    showingBillCodeAndTotalBillOrder: null,
  };

  componentDidMount() {
    const {
      handleChangeFiltersConnect,
      merchantTableInfos,
      filters,
    } = this.props;
    handleChangeFiltersConnect('status', {
      value: EnumOrderMerchantToolFilter.ALL.id,
      label: trans(EnumOrderMerchantToolFilter.ALL.label),
    });
    const { merchant } = filters;
    if (isEmptyObject(merchant)) {
      const { id: value, name: label } = merchantTableInfos[0];
      handleChangeFiltersConnect('merchant', {
        value,
        label,
        data: merchantTableInfos[0],
      });
    }
    this.searchOrder();
  }

  reloadInterval = null;

  searchOrder = () => {
    clearInterval(this.reloadInterval);
    const { getListIdsConnect, filters } = this.props;
    if (filters.isAutoReload) {
      this.reloadInterval = setInterval(
        () => getListIdsConnect(false),
        ORDER_AUTO_RELOAD_INTERVAL,
      );
    }
    getListIdsConnect(true);
  };

  changeFilterStatus = value => {
    const { filters, handleChangeFiltersConnect } = this.props;
    const { status, isAutoReload } = filters;
    if (value === null || value.value !== status.value) {
      handleChangeFiltersConnect('status', value);
    }
    clearInterval(this.reloadInterval);
    const { getListIdsConnect } = this.props;
    const isSetNewInterval =
      value &&
      value.value === EnumOrderMerchantToolFilter.New.id &&
      isAutoReload;
    if (isSetNewInterval) {
      this.reloadInterval = setInterval(
        () => getListIdsConnect(false),
        ORDER_AUTO_RELOAD_INTERVAL,
      );
    }
    getListIdsConnect(true);
  };

  toggleAutoReload = () => {
    const { filters, getListIdsConnect } = this.props;
    if (filters.isAutoReload) {
      clearInterval(this.reloadInterval);
    } else {
      this.reloadInterval = setInterval(
        () => getListIdsConnect(false),
        ORDER_AUTO_RELOAD_INTERVAL,
      );
    }
    this.props.handleChangeFiltersConnect(
      'isAutoReload',
      !filters.isAutoReload,
    );
  };

  openRejectModal = showingRejectReasonOrderId => {
    this.setState({ showingRejectReasonOrderId });
  };

  closeRejectModal = () => {
    this.setState({ showingRejectReasonOrderId: null });
  };

  openReportModal = showingReportReasonOrderId => {
    this.setState({ showingReportReasonOrderId });
  };

  closeReportModal = () => {
    this.setState({ showingReportReasonOrderId: null });
  };

  openMerchantNoteModal = showingMerchantNoteOrder => {
    this.setState({ showingMerchantNoteOrder });
  };

  closeMerchantNoteModal = () => {
    this.setState({ showingMerchantNoteOrder: null });
  };

  openBillCodeAndTotalBillModal = (showingBillCodeAndTotalBillOrder) => {
    this.setState({ showingBillCodeAndTotalBillOrder });
  };

  closeBillCodeAndTotalBillModal = () => {
    this.setState({ showingBillCodeAndTotalBillOrder: null })
  };

  submitRejectReason = async reasonId => {
    const requestData = {
      order_id: this.state.showingRejectReasonOrderId,
      order_status: EnumTableOrderStatus.CANCEL_BY_MERCHANT.id,
      reject_reason_id: reasonId,
    };
    await this.props.updateOrderStatusConnect(requestData);
    this.closeRejectModal();
  };

  submitReportReason = async userData => {
    await this.props.updateOrderInfoConnect({
      order_id: this.state.showingReportReasonOrderId,
      ...userData,
    });
    this.closeReportModal();
  };

  submitMerchantNote = async userData => {
    await this.props.updateOrderMerchantNoteConnect({
      order_id: this.state.showingMerchantNoteOrder.id,
      ...userData,
    });
    this.closeMerchantNoteModal();
  };

  submitBillCodeAndTotalBill = async (billNumber, billCode, totalBillAmount) => {
    const { updateOrderInfoConnect } = this.props;
    const { showingBillCodeAndTotalBillOrder } = this.state;
    const { id: order_id, real_adult_number } = showingBillCodeAndTotalBillOrder;

    await updateOrderInfoConnect({
      order_id,
      bill_number: billNumber,
      bill_code: billCode,
      total_bill_amount: totalBillAmount,
      real_adult_number,
    });

    this.closeBillCodeAndTotalBillModal();
  };

  render() {
    const { filters, merchantTableInfos } = this.props;

    return (
      <React.Fragment>
        <PageTitle title={trans('mtn_table_manager')} />
        <TableManagementFilter
          filters={filters}
          merchantTableInfos={merchantTableInfos}
          handleSearchOrder={this.searchOrder}
          toggleAutoReload={this.toggleAutoReload}
          changeFilterStatus={this.changeFilterStatus}
        />
        <TableManagementTable
          openRejectModal={this.openRejectModal}
          openReportModal={this.openReportModal}
          openMerchantNoteModal={this.openMerchantNoteModal}
          openBillCodeAndTotalBillModal={this.openBillCodeAndTotalBillModal}
        />
        <TableRejectOrderModal
          isOpenDialog={!isEmpty(this.state.showingRejectReasonOrderId)}
          onClose={this.closeRejectModal}
          submitRejectReason={this.submitRejectReason}
        />
        <TableReportOrderModal
          isOpenDialog={!isEmpty(this.state.showingReportReasonOrderId)}
          onClose={this.closeReportModal}
          submitReportReason={this.submitReportReason}
        />
        <TableMerchantNoteModal
          isOpenDialog={!isEmpty(this.state.showingMerchantNoteOrder)}
          onClose={this.closeMerchantNoteModal}
          submitMerchantNote={this.submitMerchantNote}
          order={this.state.showingMerchantNoteOrder}
        />
        <TableBillCodeAndTotalBillModal
          showingBillCodeAndTotalBillOrder={this.state.showingBillCodeAndTotalBillOrder}
          onClose={this.closeBillCodeAndTotalBillModal}
          submitBillCodeAndTotalBill={this.submitBillCodeAndTotalBill}
          order={this.state.showingBillCodeAndTotalBillOrder}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  table: state.table.order.table,
  filters: state.table.order.filters,
  merchantTableInfos: state.app.merchantTableInfos,
  itemEdit: state.table.order.itemEdit,
});

const mapDispatchToProps = dispatch => {
  const PAGE = EnumPage.TABLE_MANAGEMENT.id;
  return {
    closeDialogGenericConnect: () => {
      dispatch(closeDialogGeneric(PAGE));
    },
    handleChangeFiltersConnect: (name, value) => {
      dispatch(changeFilters(PAGE, name, value));
    },
    getListIdsConnect: isShowLoading => {
      dispatch(getListIds(EnumToggleType.OFF.id, isShowLoading));
    },
    getListInfoConnect: ids => dispatch(getListInfo(ids)),
    updateOrderStatusConnect: requestData =>
      dispatch(updateOrderStatus(requestData)),
    updateOrderInfoConnect: requestData =>
      dispatch(updateOrderInfo(requestData)),
    updateOrderMerchantNoteConnect: requestData =>
      dispatch(updateOrderMerchantNote(requestData)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(TableManagement),
);



// WEBPACK FOOTER //
// ./foody/src/pages/Table/TableManagement/TableManagement.jsx